import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue"
import Header from "@/modules/Missions/components/Payment/SetupPaymentHeader.vue"
import { ValidationObserver } from "vee-validate"
import MoneyInput from "@/components/widgets/input/MoneyInput.vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import { PaymentFormValues } from "@/modules/Missions/components/Payment/CreatePaymentStructureForm.vue"
import LinkPaymentPreview from "@/modules/Missions/components/Payment/LinkPaymentPreview.vue"
import { MissionLifecycleFragmentFragment, MissionScopeActivity } from "@/gql"


export default /*#__PURE__*/_defineComponent({
  __name: 'AddNewPayment',
  props: {
    form: null,
    mission: null,
    attachedDeliverables: null,
    isSubmitting: { type: Boolean },
    label: null
  },
  emits: ["back", "complete", "update-form", "linkClientPayment", "gotoDeliverables"],
  setup(__props: any, { emit }: { emit: ({
  (e: "back"): void
  (e: "complete"): void
  (e: "update-form", form: PaymentFormValues): void
  (e: "linkClientPayment", index: number): void
  (e: "gotoDeliverables", index: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  form?: PaymentFormValues
  mission: MissionLifecycleFragmentFragment
  attachedDeliverables?: MissionScopeActivity[]
  isSubmitting?: boolean
  label?: string
}





const observer = ref<InstanceType<typeof ValidationObserver> | null>(null)

const paymentForm = ref({
  amount: {
    amount: props.form?.amount?.amount ?? null,
    currency: props.form?.amount?.currency ?? "USD",
  },
  description: props.form?.description ?? "",
  clientPayment: props.form?.clientPayment ?? null,
  deliverables: props.form?.deliverables ?? [],
  name: props.form?.name,
})

watch(
  paymentForm.value,
  () => {
    emit("update-form", { ...paymentForm.value })
  },
  { deep: true }
)

const onSubmit = async () => {
  const validity = await observer.value?.validateWithInfo()

  if (!validity?.isValid) return
  emit("complete")
}

return { __sfc: true,props, emit, observer, paymentForm, onSubmit, Header, ValidationObserver, MoneyInput, Icon, LinkPaymentPreview }
}

})